import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import LayoutBody from '../LandingComponents/LayoutBody';
import Typography from '../LandingComponents/Typography';

import PubCard from "./PubCard"


const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 8,
  },
})


function PubPage(props) {
  const { classes } = props;
  return (
    <React.Fragment>
      <LayoutBody className={classes.root} component="section" width="large">
        <Typography variant="h3" gutterBottom marked="center" align="center">
          Publications
        </Typography>

        <PubCard />
        <br />
      </LayoutBody>
    </React.Fragment>
  );
}

export default withStyles(styles)(PubPage);
